export const CONNECTOR_KEY = 'wallet';

export const getStorageWallet = () => {
  return localStorage.getItem(CONNECTOR_KEY);
};
